'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (selector) {
	var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;


	var target = selector;

	if (typeof selector === 'string') {

		if (selector === '#top') {
			$('html,body').animate({
				scrollTop: 0
			}, 500);
			return;
		}
		target = $(selector);
	}

	if (target === undefined || !target || !target.length) {
		return;
	}

	var headerHeight = 80;

	if (window.matchMedia('(max-width: 768px)').matches) {
		headerHeight = document.querySelector('.c-site-header').offsetHeight;
	}

	var target_pos = target.offset().top,
	    header_comp = target_pos - headerHeight;
	header_comp = header_comp + offset;

	$('html,body').animate({
		scrollTop: header_comp
	}, 500);
};


// WEBPACK FOOTER //
// ./scripts/util/smoothScroll.js